class Api {
  constructor() {
    this.socket = null
    this.reconnectInterval = 15000
  }
  async _init() {
    await this.loadResources()
    await _$.sleep(2000)
    await this.makeConfigurations()

    this.addListeners()

    _$.vue.$on("ready", () => {
      this.initSocket().then(() => (this.socket.onmessage = event => _$.handler.emit({ type: "data_received", detail: event })))
    })

    return true
  }

  addListeners() {
    return true
  }
  async makeConfigurations() {
    InputManager.stopCurrentSource()

    var windows = ApplicationManager.getWindows()
    var whitelist = ["UI", "DEFAULT_CSP", "HBBTV", "TVSTORE"]
    for (var i = windows.length - 1; i >= 0; i--) {
      if (whitelist.indexOf(windows[i].name) == -1) {
        ApplicationManager.destroyWindow(windows[i])
      }
    }

    ApplicationManager.getCSPWindow().show()
    InputManager.stopCurrentSource()

    return true
  }
  async loadResources() {
    return true
  }
  async execute(command, expectResponse = true) {
    let temp = command.split(" ")
    command = temp.shift()
    const payload = temp.join(" ")

    if (!expectResponse) {
      if (payload !== null) Rs232LanCommand.execute(`${command} ${payload}`)
      else Rs232LanCommand.execute(command)

      return Promise.resolve(null)
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => reject("timeout"), 3000)

      Rs232LanCommand.addEventListener("executionResultEvent", __result)
      function __result(data) {
        if (data === "#*") return

        Rs232LanCommand.removeEventListener("executionResultEvent", __result)
        resolve(data)
      }

      if (payload !== null) Rs232LanCommand.execute(`${command} ${payload}`)
      else Rs232LanCommand.execute(command)
    })
  }
  async initSocket() {
    const promise = await _$.progress.create()
    if (promise.isResolved) return false

    const { host } = _$.splitUrl(__.platform.baseUrl)
    const port = __.device.config("WSOCKET_PORT")

    const self = this
    self.socket = new WebSocket(`ws://${host}:${port}`)

    self.socket.onopen = function() {
      promise.resolve()
    }
    self.socket.onerror = function() {
      setTimeout(self.connectWebSocket, self.reconnectInterval)
    }

    self.socket.onclose = function() {
      setTimeout(self.connectWebSocket, self.reconnectInterval)
    }

    return promise.done
  }
}

export default Api
